import $ from 'jquery';
import Cookies from 'js-cookie';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class FarmersLanding {
    constructor() {}

    init() {
		this.bindEvents();
		this.handleImage();
    }

    bindEvents() { 
		$(window).resize(() => {
			this.handleImage();
		});
	}

	handleImage() {
			if ($(window).width() < 998) {
				$('.widget.image-container source').attr('srcset', '/getmedia/a7b325d8-4a57-49db-8e87-6a6717fee86e/farmer-group-images-mobile.png');
			} else {
				$('.widget.image-container source').attr('srcset', '/getmedia/47a38c4d-305e-4547-bedc-4453d88570fc/group-farmer-images.png');
			}
	}
}

export default FarmersLanding;

$(() => {
	const farmersLanding = new FarmersLanding();
	farmersLanding.init();
});